import { render, staticRenderFns } from "./FactsList.vue?vue&type=template&id=790827d0&scoped=true"
import script from "./FactsList.vue?vue&type=script&lang=js"
export * from "./FactsList.vue?vue&type=script&lang=js"
import style0 from "./FactsList.vue?vue&type=style&index=0&id=790827d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790827d0",
  null
  
)

export default component.exports